import gql from 'graphql-tag';

// TODO(perf): audit this fragment for not-basic data
export const BASIC_RUN_WITHOUT_RUN_INFO_FRAGMENT = gql`
  fragment RunWithoutRunInfoStateBasicFragment on Run {
    agent {
      id
      name
    }
    commit
    computeSeconds
    createdAt
    defaultColorIndex
    displayName
    framework
    github
    group
    groupCounts
    heartbeatAt
    host
    jobType
    logLineCount
    notes
    projectId
    readOnly
    shouldStop
    state
    stopped
    sweep {
      id
      name
      displayName
      config
    }
    user {
      id
      username
      photoUrl
    }
  }
`;

export const RUN_INFO_FRAGMENT = gql`
  fragment RunInfoFragment on Run {
    runInfo {
      gpu
      gpuCount
      codePath
      codePathLocal
    }
  }
`;

export const BASIC_RUN_FRAGMENT = gql`
  fragment RunStateBasicFragment on Run {
    ...RunWithoutRunInfoStateBasicFragment
    ...RunInfoFragment
  }
  ${BASIC_RUN_WITHOUT_RUN_INFO_FRAGMENT}
  ${RUN_INFO_FRAGMENT}
`;

export const ARTIFACT_COUNTS_FRAGMENT = gql`
  fragment ArtifactCountsFragment on Run {
    inputArtifacts {
      totalCount
    }
    outputArtifacts {
      totalCount
    }
  }
`;

export const RUNS_QUERY = gql`
  query RunsStateQuery(
    $aggregationKeys: [String!]
    $configKeys: [String!]
    $enableAggregations: Boolean = false
    $enableArtifactCounts: Boolean = false
    $enableBasic: Boolean = true
    $enableConfig: Boolean = false
    $enableHistoryKeyInfo: Boolean = false
    $enableSampledHistory: Boolean = false
    $enableSummary: Boolean = false
    $enableSystemMetrics: Boolean = true
    $enableTags: Boolean = true
    $enableWandb: Boolean = false
    $entityName: String!
    $filters: JSONString!
    $groupKeys: [String!]!
    $groupLevel: Int!
    $limit: Int!
    $order: String!
    $projectName: String!
    $sampledHistorySpecs: [JSONString!]!
    $summaryKeys: [String!]
    $wandbKeys: [String!]
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      runs(
        first: $limit
        order: $order
        filters: $filters
        groupKeys: $groupKeys
        groupLevel: $groupLevel
      ) {
        totalCount
        edges {
          node {
            id
            name
            projectId
            displayName
            updatedAt
            ...ArtifactCountsFragment @include(if: $enableArtifactCounts)
            ...RunStateBasicFragment @include(if: $enableBasic)
            aggregations(keys: $aggregationKeys)
              @include(if: $enableAggregations)
            config(keys: $configKeys) @include(if: $enableConfig)
            historyKeys(format: PLAINTEXT) @include(if: $enableHistoryKeyInfo)
            sampledHistory(specs: $sampledHistorySpecs, packVersion: 1)
              @include(if: $enableSampledHistory)
            summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
            systemMetrics @include(if: $enableSystemMetrics)
            tags: tagColors @include(if: $enableTags) {
              id
              name
              colorIndex
            }
            wandbConfig(keys: $wandbKeys) @include(if: $enableWandb)
          }
        }
      }
    }
  }
  ${BASIC_RUN_FRAGMENT}
`;

export const RUNS_QUERY_WITH_PROJECT_ID = gql`
  query RunsStateQueryWithProjectId(
    $aggregationKeys: [String!]
    $configKeys: [String!]
    $enableAggregations: Boolean = false
    $enableArtifactCounts: Boolean = false
    $enableBasic: Boolean = true
    $enableConfig: Boolean = false
    $enableHistoryKeyInfo: Boolean = false
    $enableSampledHistory: Boolean = false
    $enableSummary: Boolean = false
    $enableSystemMetrics: Boolean = true
    $enableTags: Boolean = true
    $enableWandb: Boolean = false
    $filters: JSONString!
    $groupKeys: [String!]!
    $groupLevel: Int!
    $limit: Int!
    $order: String!
    $sampledHistorySpecs: [JSONString!]!
    $summaryKeys: [String!]
    $wandbKeys: [String!]
    $internalId: ID!
  ) {
    project(internalId: $internalId) {
      id
      runs(
        first: $limit
        order: $order
        filters: $filters
        groupKeys: $groupKeys
        groupLevel: $groupLevel
      ) {
        totalCount
        edges {
          node {
            id
            name
            projectId
            displayName
            updatedAt
            ...ArtifactCountsFragment @include(if: $enableArtifactCounts)
            ...RunStateBasicFragment @include(if: $enableBasic)
            aggregations(keys: $aggregationKeys)
              @include(if: $enableAggregations)
            config(keys: $configKeys) @include(if: $enableConfig)
            historyKeys(format: BITMAP) @include(if: $enableHistoryKeyInfo)
            sampledHistory(specs: $sampledHistorySpecs, packVersion: 1)
              @include(if: $enableSampledHistory)
            summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
            systemMetrics @include(if: $enableSystemMetrics)
            tags: tagColors @include(if: $enableTags) {
              id
              name
              colorIndex
            }
            wandbConfig(keys: $wandbKeys) @include(if: $enableWandb)
          }
        }
      }
    }
  }
  ${BASIC_RUN_FRAGMENT}
`;

export const RUNS_DELTA_QUERY = gql`
  query RunsStateDeltaQuery(
    $aggregationKeys: [String!]
    $configKeys: [String!]
    $currentRuns: [String!]!
    $enableAggregations: Boolean = false
    $enableArtifactCounts: Boolean = false
    $enableBasic: Boolean = true
    $enableConfig: Boolean = false
    $enableHistoryKeyInfo: Boolean = false
    $enableSampledHistory: Boolean = false
    $enableSummary: Boolean = false
    $enableSystemMetrics: Boolean = true
    $enableTags: Boolean = true
    $enableWandb: Boolean = false
    $entityName: String!
    $filters: JSONString!
    $groupKeys: [String!]!
    $groupLevel: Int!
    $lastUpdated: DateTime!
    $limit: Int!
    $order: String!
    $projectName: String!
    $sampledHistorySpecs: [JSONString!]!
    $summaryKeys: [String!]
    $wandbKeys: [String!]
  ) {
    project(name: $projectName, entityName: $entityName) {
      id
      runs(
        first: $limit
        order: $order
        filters: $filters
        groupKeys: $groupKeys
        groupLevel: $groupLevel
      ) {
        totalCount
        delta(currentRuns: $currentRuns, lastUpdated: $lastUpdated) {
          index
          op
          run {
            id
            name
            projectId
            displayName
            updatedAt
            ...ArtifactCountsFragment @include(if: $enableArtifactCounts)
            ...RunStateBasicFragment @include(if: $enableBasic)
            aggregations(keys: $aggregationKeys)
              @include(if: $enableAggregations)
            config(keys: $configKeys) @include(if: $enableConfig)
            historyKeys(format: PLAINTEXT) @include(if: $enableHistoryKeyInfo)
            sampledHistory(specs: $sampledHistorySpecs, packVersion: 1)
              @include(if: $enableSampledHistory)
            summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
            systemMetrics @include(if: $enableSystemMetrics)
            tags: tagColors @include(if: $enableTags) {
              id
              name
              colorIndex
            }
            wandbConfig(keys: $wandbKeys) @include(if: $enableWandb)
          }
        }
      }
    }
  }
  ${BASIC_RUN_FRAGMENT}
`;

export const RUNS_DELTA_QUERY_WITH_PROJECT_ID = gql`
  query RunsStateDeltaQueryWithProjectId(
    $aggregationKeys: [String!]
    $configKeys: [String!]
    $currentRuns: [String!]!
    $enableAggregations: Boolean = false
    $enableArtifactCounts: Boolean = false
    $enableBasic: Boolean = true
    $enableConfig: Boolean = false
    $enableHistoryKeyInfo: Boolean = false
    $enableSampledHistory: Boolean = false
    $enableSummary: Boolean = false
    $enableSystemMetrics: Boolean = true
    $enableTags: Boolean = true
    $enableWandb: Boolean = false
    $filters: JSONString!
    $groupKeys: [String!]!
    $groupLevel: Int!
    $lastUpdated: DateTime!
    $limit: Int!
    $order: String!
    $sampledHistorySpecs: [JSONString!]!
    $summaryKeys: [String!]
    $wandbKeys: [String!]
    $internalId: ID!
  ) {
    project(internalId: $internalId) {
      id
      runs(
        first: $limit
        order: $order
        filters: $filters
        groupKeys: $groupKeys
        groupLevel: $groupLevel
      ) {
        totalCount
        delta(currentRuns: $currentRuns, lastUpdated: $lastUpdated) {
          index
          op
          run {
            id
            name
            projectId
            displayName
            updatedAt
            ...ArtifactCountsFragment @include(if: $enableArtifactCounts)
            ...RunStateBasicFragment @include(if: $enableBasic)
            aggregations(keys: $aggregationKeys)
              @include(if: $enableAggregations)
            config(keys: $configKeys) @include(if: $enableConfig)
            historyKeys(format: BITMAP) @include(if: $enableHistoryKeyInfo)
            sampledHistory(specs: $sampledHistorySpecs, packVersion: 1)
              @include(if: $enableSampledHistory)
            summaryMetrics(keys: $summaryKeys) @include(if: $enableSummary)
            systemMetrics @include(if: $enableSystemMetrics)
            tags: tagColors @include(if: $enableTags) {
              id
              name
              colorIndex
            }
            wandbConfig(keys: $wandbKeys) @include(if: $enableWandb)
          }
        }
      }
    }
  }
  ${BASIC_RUN_FRAGMENT}
`;
